var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section", staticStyle: { flex: "1" } }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(
            _vm._s(
              _vm.$t("Warehouse.CargoDetails") +
                "(" +
                this.$t("CargoMsg.Cargo_Consignation") +
                ")"
            )
          )
        ]),
        _c(
          "div",
          { staticClass: "form-row grid-list" },
          [
            _c(
              "el-form",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: {
                  "label-width": "100px",
                  "label-position": "left",
                  disabled: !_vm.isEditing
                }
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "spacing",
                        staticStyle: { "margin-bottom": "8px" }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.jobGoodsViewType,
                              callback: function($$v) {
                                _vm.jobGoodsViewType = $$v
                              },
                              expression: "jobGoodsViewType"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: "detail" } }, [
                              _vm._v(_vm._s(_vm.$t("Warehouse.Detail")))
                            ]),
                            _c("el-radio", { attrs: { label: "summary" } }, [
                              _vm._v(_vm._s(_vm.$t("Warehouse.Summary")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        staticClass: "spacing",
                        staticStyle: { "margin-bottom": "8px" }
                      },
                      [
                        !_vm.jobGoodsViewSummary && _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.isEditing
                                },
                                on: { click: _vm.addDetailEstHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.AddCargo")))]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-dropdown",
                              {
                                staticStyle: { margin: "0 5px" },
                                attrs: {
                                  no: "exportOrderHandle",
                                  "split-button": "",
                                  type: "primary",
                                  disabled:
                                    _vm.hasChecklistTime || _vm.isEditing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.exportOrderHandle()
                                  },
                                  command: function(p) {
                                    _vm.exportOrderCommand = p
                                    _vm.exportOrderHandle()
                                  }
                                }
                              },
                              [
                                _vm.exportOrderCommand ===
                                this.$t("CargoMsg.Cargo_DownloadTemplate")
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.exportOrderCommand))
                                    ])
                                  : _vm._e(),
                                [
                                  _vm.$t("SeaExport.BatchImport"),
                                  _vm.$t("SeaExport.GoodsInformationImport")
                                ].includes(_vm.exportOrderCommand)
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          "margin-left": "5px"
                                        },
                                        attrs: {
                                          action: _vm.URL.fba.batchImport,
                                          headers: _vm.headers,
                                          "show-file-list": false,
                                          accept: ".xls, .xlsx",
                                          "before-upload":
                                            _vm.beforeOrderUpload,
                                          "on-success": _vm.uploadOrderSuccess,
                                          "on-error": _vm.handleError,
                                          data: { uuid: _vm.jobUuid }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "white" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                [
                                                  _vm.$t(
                                                    "SeaExport.BatchImport"
                                                  ),
                                                  _vm.$t(
                                                    "SeaExport.GoodsInformationImport"
                                                  )
                                                ].includes(
                                                  _vm.exportOrderCommand
                                                )
                                                  ? _vm.exportOrderCommand
                                                  : ""
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    style: {
                                      minWidth: _vm.$selectByLang(
                                        "80px",
                                        "80px",
                                        "80px",
                                        "140px",
                                        "140px",
                                        "140px"
                                      )
                                    },
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.GoodsInformationImport"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "uploadOrder",
                                            staticStyle: {
                                              display: "inline-block"
                                            },
                                            attrs: {
                                              action: _vm.URL.fba.batchImport,
                                              headers: _vm.headers,
                                              "show-file-list": false,
                                              accept: ".xls, .xlsx",
                                              "before-upload":
                                                _vm.beforeOrderUpload,
                                              "on-success":
                                                _vm.uploadOrderSuccess,
                                              "on-error": _vm.handleError,
                                              data: { uuid: _vm.jobUuid }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "padding-left": "0px",
                                                  color: "#6F6F6F",
                                                  "text-align": "left",
                                                  width: "80px"
                                                },
                                                attrs: {
                                                  slot: "trigger",
                                                  type: "text"
                                                },
                                                slot: "trigger"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.GoodsInformationImport"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.GoodsInformationImport"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "padding-left": "0px",
                                              color: "#6F6F6F",
                                              "text-align": "left",
                                              width: "80px"
                                            },
                                            attrs: { no: "16", type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downLoadDetail()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_DownLoad_Detail"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.GoodsInformationImport"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "padding-left": "0px",
                                              color: "#6F6F6F",
                                              "text-align": "left",
                                              width: "80px"
                                            },
                                            attrs: { no: "16", type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downLoadSummary()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_DownLoad_Summary"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.isEditing
                                },
                                on: { click: _vm.batchMaintenanceEst }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Warehouse.BatchMaintenance"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled:
                                    !_vm.isEditing || _vm.hasChecklistTime
                                },
                                on: { click: _vm.clearDataEst }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled: !_vm.isEditing
                                },
                                on: { click: _vm.delDetailEstHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.DeleteCargo")))]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    !_vm.jobGoodsViewSummary
                      ? _c("cargo-ag-grid", {
                          ref: "goodsDetailTableEst",
                          staticStyle: { height: "200px" },
                          attrs: {
                            "config-module": "9300021",
                            "grid-options": _vm.detailList.goodGridOptionsEst,
                            "column-defs": _vm.dynamicGoodsColumnEstDefs,
                            "row-data": _vm.form.fbaJobGoods || []
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.detailList.gridApiEst = params.api
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.jobGoodsViewSummary
                      ? _c("cargo-ag-grid", {
                          ref: "goodsSummaryTableEst",
                          staticStyle: { height: "200px" },
                          attrs: {
                            "config-module": "9300022",
                            "grid-options": _vm.detailList.goodGridOptionsEst,
                            "column-defs": _vm.dynamicGoodsColumnEstDefs,
                            "row-data": _vm.summaryJobGoodsDetailList || []
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.detailList.gridApiEst = params.api
                            }
                          }
                        })
                      : _vm._e(),
                    _c("el-form-item", { staticClass: "auto-width" }, [
                      _c(
                        "div",
                        {
                          staticClass: "title-row",
                          staticStyle: { display: "flex", "text-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "100px",
                                "text-align": "right"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "170px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Weight2")) + " KGS"
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "150px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Cubage")) + " CBM"
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "150px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.VolumetricWeight")) +
                                  " KGS"
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "170px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                  " M/T"
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { label: _vm.$t("SeaExport.Consignation") }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.quantityContract,
                              expression: "form.quantityContract"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.quantitySum) ===
                              Number(_vm.form.quantityContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.quantityContract },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "quantityContract",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.weightContract,
                              expression: "form.weightContract"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.weightSum) ===
                              Number(_vm.form.weightContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.weightContract },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "weightContract",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.cubageContract,
                              expression: "form.cubageContract"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.cubageSum) ===
                              Number(_vm.form.cubageContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.cubageContract },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "cubageContract",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.volumetricWeightContract,
                              expression: "form.volumetricWeightContract"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.volumetricWeightAct) ===
                              Number(_vm.form.volumetricWeightContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: {
                            value: _vm.form.volumetricWeightContract
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "volumetricWeightContract",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.chargeWeightContract,
                              expression: "form.chargeWeightContract"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.chargeWeightAct) ===
                              Number(_vm.form.chargeWeightContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: !_vm.isEditing },
                          domProps: { value: _vm.form.chargeWeightContract },
                          on: {
                            change: _vm.changeChargeWeightContract,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "chargeWeightContract",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "section", staticStyle: { flex: "1" } }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(
            _vm._s(
              _vm.$t("Warehouse.CargoDetails") +
                "(" +
                this.$t("SeaExport.Actual") +
                ")"
            )
          )
        ]),
        _c(
          "div",
          { staticClass: "form-row grid-list" },
          [
            _c(
              "el-form",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: {
                  "label-width": "100px",
                  "label-position": "left",
                  disabled: !_vm.isEditing
                }
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "spacing",
                        staticStyle: { "margin-bottom": "8px" }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.goodsViewType,
                              callback: function($$v) {
                                _vm.goodsViewType = $$v
                              },
                              expression: "goodsViewType"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: "detail" } }, [
                              _vm._v(_vm._s(_vm.$t("Warehouse.Detail")))
                            ]),
                            _c("el-radio", { attrs: { label: "summary" } }, [
                              _vm._v(_vm._s(_vm.$t("Warehouse.Summary")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        staticClass: "spacing",
                        staticStyle: { "margin-bottom": "8px" }
                      },
                      [
                        !_vm.goodsViewSummary && _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled:
                                    !_vm.isEditing || _vm.hasChecklistTime
                                },
                                on: { click: _vm.addDetailHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.AddCargo")))]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled:
                                    !_vm.isEditing || _vm.hasChecklistTime
                                },
                                on: { click: _vm.batchMaintenance }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Warehouse.BatchMaintenance"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-dropdown",
                              {
                                staticStyle: {
                                  margin: "0 5px",
                                  "font-size": "12px"
                                },
                                attrs: { no: "14" }
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-left": "5px"
                                    },
                                    attrs: {
                                      action: _vm.actionOrderUrl,
                                      headers: _vm.headers,
                                      "show-file-list": false,
                                      accept: ".xls, .xlsx",
                                      "before-upload": _vm.beforeOrderUpload,
                                      "on-success": _vm.uploadOrderSuccess,
                                      "on-error": _vm.handleError,
                                      data: { uuid: _vm.jobUuid, type: "SE" },
                                      disabled:
                                        _vm.hasChecklistTime || _vm.isEditing
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.hasChecklistTime ||
                                            _vm.isEditing
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Import2")
                                            ) +
                                            " "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    style: {
                                      minWidth: _vm.$selectByLang(
                                        "80px",
                                        "80px",
                                        "80px",
                                        "140px",
                                        "140px",
                                        "140px"
                                      )
                                    },
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: 1 } },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "uploadOrder",
                                            staticStyle: {
                                              display: "inline-block"
                                            },
                                            attrs: {
                                              action: _vm.actionOrderUrl,
                                              headers: _vm.headers,
                                              "show-file-list": false,
                                              accept: ".xls, .xlsx",
                                              "before-upload":
                                                _vm.beforeOrderUpload,
                                              "on-success":
                                                _vm.uploadOrderSuccess,
                                              "on-error": _vm.handleError,
                                              data: {
                                                uuid: _vm.jobUuid,
                                                type: "SE"
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "padding-left": "0px",
                                                  color: "#6F6F6F",
                                                  "text-align": "left",
                                                  width: "80px"
                                                },
                                                attrs: {
                                                  slot: "trigger",
                                                  type: "text"
                                                },
                                                slot: "trigger"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.GOODS_INFO_IMPORT"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "padding-left": "0px",
                                              color: "#6F6F6F",
                                              "text-align": "left",
                                              width: "80px"
                                            },
                                            attrs: { no: "16", type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downLoadDetail()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_DownLoad_Detail"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "padding-left": "0px",
                                              color: "#6F6F6F",
                                              "text-align": "left",
                                              width: "80px"
                                            },
                                            attrs: { no: "17", type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downLoadSummary()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_DownLoad_Summary"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled:
                                    _vm.isEditing ||
                                    !(
                                      _vm.form.warehouseInDetailList &&
                                      _vm.form.warehouseInDetailList.length > 0
                                    )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onCheckList()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.Checklist")))]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled:
                                    !_vm.isEditing || _vm.hasChecklistTime
                                },
                                on: { click: _vm.pickingGoods }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.PickingGoods")))]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled:
                                    !_vm.isEditing || _vm.hasChecklistTime
                                },
                                on: { click: _vm.clearData }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                            )
                          : _vm._e(),
                        _vm.editPermission
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled:
                                    !_vm.isEditing || _vm.hasChecklistTime
                                },
                                on: { click: _vm.delDetailHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.DeleteCargo")))]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      { attrs: { disabled: _vm.hasChecklistTime } },
                      [
                        !_vm.goodsViewSummary
                          ? _c("cargo-ag-grid", {
                              ref: "goodsDetailTable",
                              staticStyle: { height: "200px" },
                              attrs: {
                                "config-module": "9300023",
                                "grid-options": _vm.detailList.goodGridOptions,
                                "column-defs": _vm.dynamicGoodsColumnDefs,
                                "row-data": _vm.form.warehouseInDetailList || []
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.detailList.gridApi = params.api
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.goodsViewSummary
                          ? _c("cargo-ag-grid", {
                              ref: "goodsSummaryDTable",
                              staticStyle: { height: "200px" },
                              attrs: {
                                "config-module": "9300024",
                                "grid-options": _vm.detailList.goodGridOptions,
                                "column-defs": _vm.dynamicGoodsColumnDefs,
                                "row-data": _vm.summaryGoodsDetailList || []
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.detailList.gridApi = params.api
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("el-form-item", { staticClass: "auto-width" }, [
                      _c(
                        "div",
                        {
                          staticClass: "title-row",
                          staticStyle: { display: "flex", "text-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "100px",
                                "text-align": "right"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "170px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Weight2")) + " KGS"
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "150px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Cubage")) + " CBM"
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "150px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.VolumetricWeight")) +
                                  " KGS"
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "170px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                  " M/T"
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { label: _vm.$t("SeaExport.Actual") }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.quantitySum,
                              expression: "form.quantitySum"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.quantitySum) ===
                              Number(_vm.form.quantityContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.quantitySum },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "quantitySum",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.weightSum,
                              expression: "form.weightSum"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.weightSum) ===
                              Number(_vm.form.weightContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.weightSum },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "weightSum",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.cubageSum,
                              expression: "form.cubageSum"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.cubageSum) ===
                              Number(_vm.form.cubageContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.cubageSum },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "cubageSum",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.volumetricWeightAct,
                              expression: "form.volumetricWeightAct"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.volumetricWeightAct) ===
                              Number(_vm.form.volumetricWeightContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: "" },
                          domProps: { value: _vm.form.volumetricWeightAct },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "volumetricWeightAct",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.chargeWeightAct,
                              expression: "form.chargeWeightAct"
                            }
                          ],
                          style: {
                            color:
                              Number(_vm.form.chargeWeightAct) ===
                              Number(_vm.form.chargeWeightContract)
                                ? "black"
                                : "red",
                            minHeight: "28px",
                            minLength: "104px",
                            textAlign: "center"
                          },
                          attrs: { disabled: !_vm.isEditing },
                          domProps: { value: _vm.form.chargeWeightAct },
                          on: {
                            change: _vm.changeChargeWeightAct,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "chargeWeightAct",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm.checklist.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.checklist.visible,
                title: _vm.$t("Warehouse.Checklist"),
                width: "340px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.checklist, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.ChecklistTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          no: "checklistTime",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder: _vm.$t("SeaExport.SelectTime")
                        },
                        model: {
                          value: _vm.checklist.checklistTime,
                          callback: function($$v) {
                            _vm.$set(_vm.checklist, "checklistTime", $$v)
                          },
                          expression: "checklist.checklistTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.ChecklistResult") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "195px" },
                          attrs: { no: "checklistStatus", placeholder: "" },
                          model: {
                            value: _vm.checklist.checklistStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.checklist, "checklistStatus", $$v)
                            },
                            expression: "checklist.checklistStatus"
                          }
                        },
                        _vm._l(_vm.SystemConstants.CHECKLIST_STATUS, function(
                          item
                        ) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.HandlingOpinions") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: { type: "textarea", row: 5 },
                        model: {
                          value: _vm.checklist.comments,
                          callback: function($$v) {
                            _vm.$set(_vm.checklist, "comments", $$v)
                          },
                          expression: "checklist.comments"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toChecklist }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.checklist.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.batchMaintenanceDialog.visible
        ? _c("batch-maintenance-dialog", {
            attrs: {
              visible: _vm.batchMaintenanceDialog.visible,
              "job-key": _vm.jobUuid,
              "exist-detail-list": _vm.batchMaintenanceDialog.est
                ? _vm.form.fbaJobGoods
                : _vm.form.warehouseInDetailList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchMaintenanceDialog, "visible", $event)
              },
              saveCallBack: _vm.batchMaintenanceDialog.saveCallBack,
              close: function($event) {
                _vm.batchMaintenanceDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.containerNoEditor.visible
        ? _c("container-no-editor", {
            attrs: {
              "boxes-number": _vm.containerNoEditor.boxesNumber,
              visible: _vm.containerNoEditor.visible,
              "shipment-id": _vm.containerNoEditor.shipmentId,
              source: _vm.containerNoEditor.source,
              "container-no": _vm.containerNoEditor.containerNo,
              "warehouse-in-detail-list": _vm.containerNoEditor.detailList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.containerNoEditor, "visible", $event)
              },
              summarySaveCallBack: _vm.containerNoEditor.summarySaveCallBack,
              detailSaveCallBack: _vm.containerNoEditor.detailSaveCallBack,
              close: function($event) {
                _vm.containerNoEditor.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }